import React from 'react';
import './BlogSingle.css';

import { BlogSidebar, Comments, Lightbox, PageTitle } from '../../../components';
import { blogContent } from '../../../constants';
import { useBlogFilter } from '../../../utils';

import { FaFacebookF, FaInstagram, FaLinkedin, FaUserCircle, FaQuoteLeft, FaTags } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { Link, useLocation } from "react-router-dom";



const BlogSingle = () => {

  // Extract necessary data and functions from useBlogFilter
  const { 
    selectedCategory,
    selectedTag,
    handleSearchSubmit,
  } = useBlogFilter(blogContent);

  const location = useLocation();
  const blog = location.state;

  const blogComments = blog.comments;

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    event.target.reset(); // Reset the form fields
  };

  return (
    <>
      {/* Page title */}
      <PageTitle title={'blog single'} page={'blog single'} />

      {/* Blog Single Section */}
      <section className='blog-single'>

        <div className='blog-container'>

          <div className='blog-info page-info' key={blog.id}>

            <div className='image'>
              <img src={blog.image} alt={blog.heading} /> {/* Blog image */}
              <div className='date'>{blog.date.substring(0, blog.date.indexOf(","))}</div> {/* Blog publication date */}
            </div>

            <div className='content'>

              <h3 className='main-heading'>{blog.heading}</h3> {/* Blog heading */}

              <div className='details'>
                <h3><FaUserCircle className='icon' /><span>By {blog.admin}</span> </h3> {/* Blog author */}
                <h3><FaTags className='icon' />         
                  <Link
                    className='category'
                    key={blog.id}
                    to={`/Blogs/category/${blog.category}`}>
                    {blog.category}
                  </Link> </h3> {/* Blog Category */}
              </div> 

              {/* Blog Paragraphs */}
              <p>{blog.paragraph.para1}</p>
              <p>{blog.paragraph.para2}</p>

              {/* Important quote */}
              <div className="imp">
                <FaQuoteLeft className="icon" />
                <div className="box-container">
                  {blog.important.content}
                  <div className="intro">
                    <span></span>
                    <h6>{blog.important.intro}</h6>
                  </div>
                </div>
              </div>

              <p>{blog.paragraph.para3}</p>

              <Lightbox images={blog.gallery} className={'blog'} /> {/* Display the image gallery using the Lightbox component */}

              <p>{blog.paragraph.para4}</p>

              <div className='end-details'>

                {/* Blog tags */}
                <div className='tags'>
                  {blog.tags.map((item, index) => (
                    <Link
                      className='item'
                      key={index}
                      to={`/Blogs/tag/${item}`}>
                      {item}
                    </Link>
                  ))}
                </div> 

                {/* Share buttons */}
                <div className='share'>
                  <h3>share:</h3>
                  <FaFacebookF className='icon' />
                  <FaLinkedin className='icon' />
                  <FaXTwitter className='icon' />
                  <FaInstagram className='icon' />
                </div>
                
              </div>
            </div>
          </div>

          {/* Comments section */}
          <Comments comments={blogComments} />

          {/* Leave a comment */}
          <div className='leave-reply'>
            <form className='form' onSubmit={handleSubmit}>
              <h3>leave a comment</h3> {/* Heading for the comment form */}
              <div className='input-box'>
                <input type="text" name="name" className='box' id="name" placeholder="name" required /> {/* Input field for name */}
                <input type="email" name="email" className='box' id="email" placeholder="email" required /> {/* Input field for email */}
              </div>
              <textarea cols="30" rows="10" name="comment" className='box' id="comment" placeholder="comment"></textarea> {/* Textarea for the comment */}
              <button type="submit" name="submit" id="submit" className='btn'>submit</button> {/* Submit button */}
            </form>
          </div>

        </div>

        {/* Blog Sidebar */}
        <BlogSidebar
          selectedCategory={selectedCategory}
          selectedTag={selectedTag}
          handleSubmit={handleSearchSubmit}
        /> 

      </section>

    </>

  )
}

export default BlogSingle;